<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.2" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.14" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />


<app-navbar></app-navbar>

<div *ngIf="section" class="terms" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%" fxLayoutGap="50px">

        <!-- Navigation Page - Hide in Mobile -->
        <div class="lateral-bar" fxFlex="25%" fxHide.lt-md>
            <mat-list role="list">
                <mat-list-item *ngFor="let item of section.data.list; let index = index;" role="listitem" [ngx-scroll-to]="'section_' + index" [ngx-scroll-to-offset]="-50">{{ item.title }}</mat-list-item>
                <mat-list-item role="listitem">
                    <div class="download">
                        <h4><a href="{{ section.data.url_pdf }}" target="_blank"><span class="jam jam-cloud-f"></span> Descargar PDF</a></h4>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>

        <!-- Only Mobile - Title -->
        <div class="title-mobile" fxLayoutGap="20px" fxHide fxShow.lt-md>
            <div class="icon" fxFlex="50px"><span class="jam jam-document"></span></div>
            <div class="texts" fxFlex="300">
                <h1>{{ section.title }}</h1>
                <p><small>Última modificación: {{ section.data.last_date }}</small></p>
            </div>
        </div>
        <div fxHide fxShow.xs class="hr"></div>

        <!-- Only Mobile - Navigation Page -->
        <div class="lateral-bar-mobile" fxHide fxShow.lt-md>
            <mat-form-field>
                <mat-label>Ir a la sección...</mat-label>
                <mat-select>
                    <mat-option>Ir a la sección...</mat-option>
                    <mat-option *ngFor="let item of section.data.list; let index = index;" [ngx-scroll-to]="'section_' + index" [ngx-scroll-to-offset]="-100" value="{{ item.title }}">{{ item.title }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Page -->
        <div class="text" fxFlex="75%" fxFlex.xs="100%">
            <div class="date" fxHide.xs>
                <p>última modificación - <strong>{{ section.data.last_date }}</strong></p>
            </div>
            <h1 fxHide.xs>{{ section.title }}</h1>

            <ng-container *ngFor="let item of section.data.list; let index = index;">
                <h2 [id]="'section_' + index">{{ item.title }}</h2>
                <ng-container *ngFor="let sub of item.items">
                    <h4 *ngIf="sub.title != ''">{{ sub.title }}</h4>
                    <p>{{ sub.caption }}</p>
                </ng-container>
            </ng-container>


        </div> <!-- fxFlex -->

    </div>
</div>

<app-footer></app-footer>